/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Fragment, createInterpolateElement, RawHTML } from '@wordpress/element';
import { format } from '@wordpress/date';

function Days( { date } ) {
	const days = date ?? Object.keys( date.days );
	if ( ! days.length ) {
		return null;
	}
	return (
		<Fragment>
			<br />
			{ sprintf(
				/* Translators: days names */
				__( 'Custom Days: %s', 'popper' ),
				days.join( ', ' )
			) }
		</Fragment>
	);
}

function Time( { date } ) {
	if ( ! date.customTime ) {
		return null;
	}

	return (
		<Fragment>
			<RawHTML>
				{ sprintf(
					/* Translators: 1. start time 2. end time */
					__( '<b>From:</b> %1$s <b>To:</b> %2$s', 'popper' ),
					Object.values( date.startTime ).join( ':' ),
					Object.values( date.endTime ).join( ':' )
				) }
			</RawHTML>
		</Fragment>
	);
}

function DatesField( { item } ) {
	const date = item.meta.popper_rules.date;
	if ( 'custom' === date.type ) {
		const startDate = format(
			'M j, Y G:i',
			item.popper_locations.date.startDate
		);
		const endDate = format(
			'M j, Y G:i',
			item.popper_locations.date.endDate
		);
		return (
			<div>
				<RawHTML>
					{ sprintf(
						/* Translators: 1. start date 2. end date */
						__( '<b>From:</b> %1$s <b>To:</b> %2$s', 'popper' ),
						startDate,
						endDate
					) }
				</RawHTML>
				<Time date={ date } />
				<Days date={ date } />
			</div>
		);
	}
	return (
		<div>
			{ date.type }
			<Time date={ date } />
			<Days date={ date } />
		</div>
	);
}

export const datesField = {
	label: __( 'Dates' ),
	id: 'dates',
	getValue: ( item ) => item.meta.popper_rules?.date,
	render: DatesField,
	enableSorting: false,
};
